<template>
  <div>
    <div class="mb-1">
      <span class="font-weight-bold h6">{{ typeVariables.title }}</span>
      <a class="d-inline ml-1 link" href="#" @click.prevent="addNew">
        <i class="fa fa-plus fa-lg"></i>
      </a>
    </div>
    <div class="mb-1" :title="detail.description" v-for="(detail) in details">
      <span v-if="!isEditing(detail)" class="show-icon-on-hover">
        <a :href="typeVariables.linkPrefix + detail.value" target="_blank">
          &nbsp;
          {{ detail.value }}
        </a>
        <a href="#">
          <i class="fa fa-lg fa-edit to-show ml-1" @click.prevent="edit(detail)"></i>
        </a>
        <a href="#">
          <i
            class="fa fa-lg fa-trash to-show ml-1"
            @click.prevent="$emit('delete', detail)"
          ></i>
        </a>
      </span>
      <form v-if="isEditing(detail)" @submit.prevent="$emit('save', formData)">
        <div class="input-group mb-2">
          <input class="form-control" :type="typeVariables.formType" v-model="formData.value" :placeholder="typeVariables.placeholder" required/>
          <div class="input-group-append">
            <input class="btn btn-outline-primary" type="submit" value="Save" />
            <a
              href="#"
              class="btn btn-outline-secondary"
              @click.prevent="cancelEdit(detail)"
            >Cancel</a>
          </div>
        </div>
      </form>
    </div>
    <p v-if="detailList.length < 1" class="font-italic text-muted mb-1">&nbsp; No {{ typeVariables.empty }}</p>
  </div>
</template>

<script>
import Vue from "vue";

const types = {
   email: {
     title: 'Email addresses',
     type: 0,
     formType: 'email',
     linkPrefix: 'mailto:',
     placeholder: 'user@example.com',
   },
   phone: {
     title: 'Phone numbers',
     type: 1,
     formType: 'text',
     linkPrefix: 'tel:',
     placeholder: '0800 123 4567',
   },
   url: {
     title: 'Links',
     type: 2,
     formType: 'url',
     linkPrefix: '',
     placeholder: 'https://example.com',
   }
}

export default {
   props: ["detailList", "type"],
   data() {
     return {
       formData: null,
     };
   },
   computed: {
     details() {
       let details = this.detailList;
       if (this.formData && this.formData.id === 'new') {
         details.push(this.formData);
       }
       return details;
     },
     isEditing() {
       return (detail) => {
         return this.formData && this.formData.id === detail.id;
       }
     },
     typeVariables() {
       let vars = types[this.type];
       vars.empty = vars.title.slice(0, 1).toLowerCase() + vars.title.slice(1);
       return vars
     },
     blankDetail() {
       return
     },
   },
   methods: {
     edit(detail) {
       // make a copy to prevent changing it until the form is successfully submitted
       this.formData = Object.assign({}, detail);
     },
     cancelEdit(detail) {
       this.formData = null;
     },
     addNew() {
       this.formData = {
         id: 'new',
         value: '',
         type: this.typeVariables.type,
       };
     }
   }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/ContactDetailsListRow.vue